import React, { Component } from "react";

export default class TablaFila extends Component {
	render() {
		let clase =
			this.props.ultima === this.props.clas_sesion_num ? "tablaNuevas" : "";
		return (
			<tbody className={clase}>
				{this.props.cat === "comparsa" ? (
					<tr className="tablaFila" key={this.props.grupo.nom}>
						<td>{this.props.indice}.</td>
						<td className="tablaNombre">{this.props.grupo.nom}</td>
						<td>{this.props.grupo[`${this.props.fase}tip`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pre`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pas`]}</td>
						<td>{this.props.grupo[`${this.props.fase}cup`]}</td>
						<td>{this.props.grupo[`${this.props.fase}est`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pop`]}</td>
						<td>
							{this.props.grupo[`${this.props.fase}tot`] -
								this.props.grupo["cuar_tot"]}
						</td>
						<td>{this.props.grupo["cuar_tot"]}</td>
						<td className="tablaTotal">
							<bold>{this.props.grupo[`${this.props.fase}tot`]}</bold>
						</td>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "chirigota" ? (
					<tr className="tablaFila" key={this.props.grupo.nom}>
						<td>{this.props.indice}.</td>
						<td className="tablaNombre">{this.props.grupo.nom}</td>
						<td>{this.props.grupo[`${this.props.fase}tip`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pre`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pas`]}</td>
						<td>{this.props.grupo[`${this.props.fase}cup`]}</td>
						<td>{this.props.grupo[`${this.props.fase}est`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pop`]}</td>
						<td>
							{this.props.grupo[`${this.props.fase}tot`] -
								this.props.grupo["cuar_tot"]}
						</td>
						<td>{this.props.grupo["cuar_tot"]}</td>

						<td className="tablaTotal">
							<bold>{this.props.grupo[`${this.props.fase}tot`]}</bold>
						</td>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "coro" ? (
					<tr className="tablaFila" key={this.props.grupo.nom}>
						<td>{this.props.indice}.</td>
						<td className="tablaNombre">{this.props.grupo.nom}</td>
						<td>{this.props.grupo[`${this.props.fase}tip`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pre`]}</td>
						<td>{this.props.grupo[`${this.props.fase}tan`]}</td>
						<td>{this.props.grupo[`${this.props.fase}cup`]}</td>
						<td>{this.props.grupo[`${this.props.fase}est`]}</td>
						<td>{this.props.grupo[`${this.props.fase}pop`]}</td>
						<td>
							{this.props.grupo[`${this.props.fase}tot`] -
								this.props.grupo["cuar_tot"]}
						</td>
						<td>{this.props.grupo["cuar_tot"]}</td>

						<td className="tablaTotal">
							<bold>{this.props.grupo[`${this.props.fase}tot`]}</bold>
						</td>
					</tr>
				) : (
					""
				)}
				{this.props.cat === "cuarteto" ? (
					<tr className="tablaFila" key={this.props.grupo.nom}>
						<td>{this.props.indice}.</td>
						<td className="tablaNombre">{this.props.grupo.nom}</td>
						<td>{this.props.grupo[`${this.props.fase}tip`]}</td>
						<td>{this.props.grupo[`${this.props.fase}par`]}</td>
						<td>{this.props.grupo[`${this.props.fase}cup`]}</td>
						<td>{this.props.grupo[`${this.props.fase}est`]}</td>
						<td>{this.props.grupo[`${this.props.fase}otr`]}</td>
						<td>
							{this.props.grupo[`${this.props.fase}tot`] -
								this.props.grupo["cuar_tot"]}
						</td>
						<td>{this.props.grupo["cuar_tot"]}</td>

						<td className="tablaTotal">
							<bold>{this.props.grupo[`${this.props.fase}tot`]}</bold>
						</td>
					</tr>
				) : (
					""
				)}
			</tbody>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TablaFila.js